import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  &[aria-hidden='true'] {
    display: none;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.55);
`;

export const Content = styled.div`
  margin: auto;
  border-radius: 4px;
  z-index: 999;
  position: relative;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  /* overflow: auto; */
  max-height: 90vh;
  min-width: 380px;
  ${(props) =>
    props.$w &&
    css`
      width: ${props.$w}px;
    `}
`;

export const Title = styled.div`
  padding: ${(props) => props.$pad}px;
  font-size: 20px;
  line-height: 1;
  background: #fafafa;
  font-weight: bold;
  /* text-align: center; */
  border-bottom: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
`;

export const ContentInner = styled.div`
  padding: ${(props) => props.$pad}px;
`;

export const Buttons = styled.div`
  padding: ${(props) => props.$pad}px;
  background: #f9f9f9;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-top: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 4px 4px;
  & > button {
    margin: 0;
    height: ${(props) => props.$pad * 2}px;
    min-width: ${(props) => props.$pad * 8}px;
  }
  ${(props) =>
    props.$align === 'left' &&
    css`
      justify-content: flex-start;
      & > button {
        margin: 0 ${(props) => props.$pad}px 0 0;
      }
    `}
  ${(props) =>
    props.$align === 'right' &&
    css`
      justify-content: flex-end;
      & > button {
        margin: 0 0 0 ${(props) => props.$pad}px;
      }
    `}
  ${(props) =>
    props.$pl &&
    css`
      padding-left: ${(props) => props.$pl};
    `}
`;
